import style from './policy.module.css';
import PrivacyPolicyContent from './PrivacyPolicyContent';

function PolicyApp() {
    return (
        <main className={style.policy}>
            <PrivacyPolicyContent />
        </main>
    );
}

export default PolicyApp;
